import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Size = 'small' | 'medium' | 'large';

type Props = {
  size: Size;
};

export const OuterLayout = styled.div<Props>(
  ({size}) => css`
    display: grid;
    grid-template-columns: ${{
      small: '64px 1fr',
      medium: '108px 1fr',
      large: '120px 1fr',
    }[size]};
    grid-column-gap: ${{
      small: '8px',
      medium: '8px',
      large: '16px',
    }[size]};
  `
);
